import { api, RouteAPI } from "../service/apiService";

export const fetchGooglePlaces = async (
    input: string,
    countryName: string,
    countryCode: string
): Promise<string[]> => {
    try {
        const { data, status } = await api(RouteAPI.CITY_AUTOCOMPLETE, "POST", {
            input,
            countryName,
            countryCode,
        });

        if (status !== 200) return [];

        return data.suggestions.map((item: any) => {
            const fullText = item.placePrediction.text.text;
            return fullText.split(",")[0].trim();
        });
    } catch (error) {
        console.error("Failed to fetch city suggestions:", error);
        return [];
    }
};
